import React, { useEffect, useRef, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Scanner } from '@yudiel/react-qr-scanner';
import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import Api from '../../../api/api';
import accountHelpers from '../../../utils/accountHelpers';
import classes from './delivery_sign.module.scss';
import { useQuery } from '../../../utils/hooks/useQuery';
import Button from '../../_common/Form/Buttons/Button';
import Modal from '../../_common/Modal/Modal';

const DriverDeliverySign = () => {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();

  const { query } = useQuery();

  const { attachmentId, patientId, physicianId } = query;

  const signPad = useRef(null);

  const [saveLoading, saveLoadingToggle] = useState(false);

  const [signatureFile, setSignatureFile] = useState(null);

  const [error, setError] = useState(false);

  const [modalData, setModalData] = useState({
    // deliveries: [],
    // addMoreOpen: false,
    scannerOpen: false,
    selectedIds: [],
  });

  const { scannerOpen, selectedIds } = modalData;

  // const [loading, loadingToggle] = useState(true);
  //
  // useEffect(() => {
  //   (async () => {
  //     try {
  //       const { data } = await Api.getDriverDeliveries({ attachmentId, patientId, physicianId });
  //
  //       changeModalData({ deliveries: data.result });
  //     } catch (e) {
  //       console.warn(e);
  //     }
  //
  //     loadingToggle(false);
  //   })();
  // }, []);

  const changeModalData = (patch) => setModalData((prev) => ({ ...prev, ...patch }));

  const addSignature = () => {
    fetch(signPad.current.toDataURL())
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], 'image.png', { type: 'image/png' });
        setSignatureFile(file);
      });

    setError(false);
  };

  const saveSignature = async () => {
    if (!signatureFile) {
      setError(true);
      toast.error('Please sign');
    } else {
      try {
        saveLoadingToggle(true);

        await Api.signDriverDelivery({
          physicianId,
          attachmentIds: [attachmentId, ...selectedIds],
          patientId,
          signatureFile,
          userId: accountHelpers.getUser().id,
        });

        navigate(`/deliveries${state || ''}`);
      } catch (e) {
        console.warn(e);

        toast.error(e.response?.data?.message || 'Something went wrong');
      }

      saveLoadingToggle(false);
    }
  };

  const clearSignature = () => {
    signPad.current.clear();
    setSignatureFile(null);
  };

  const scan = (detectedCodes) => {
    const rawValue = detectedCodes[0]?.rawValue;

    console.log(rawValue);

    if (!rawValue) return;

    let scannedUrl;

    try {
      scannedUrl = new URL(rawValue);
    } catch (e) {
      toast.error('Invalid QR code');
      return;
    }

    if (scannedUrl.pathname !== pathname) {
      toast.error('Invalid QR code');
      return;
    }

    const scannedAttachmentId = scannedUrl.searchParams.get('attachmentId');

    if (!scannedAttachmentId) {
      toast.error('Invalid QR code');
      return;
    }

    if (scannedAttachmentId === attachmentId || selectedIds.includes(scannedAttachmentId)) {
      toast.error('This delivery is already added');
      return;
    }

    changeModalData({ selectedIds: [...selectedIds, scannedAttachmentId] });

    toast.success('QR successfully scanned');

    setTimeout(() => changeModalData({ scannerOpen: false }), 500);
  };

  console.log({ selectedIds });

  // const modalTableHeader = useMemo(() => [
  //   { name: 'Physician Name', path: 'physicianName' },
  //   { name: 'Address', path: 'address' },
  //   { name: 'Ship On', path: 'shipOn' },
  //   {
  //     name: 'Title',
  //     path: 'title',
  //     render: (d) => (
  //       <span
  //         className={classes.download_link}
  //         onClick={async (e) => {
  //           e.stopPropagation();
  //           const response = await fetch(d.link);
  //           const blob = await response.blob();
  //           fileDownload(blob, d.title);
  //         }}
  //       >
  //         {d.title}
  //       </span>
  //     ),
  //   },
  // ], []);

  return (
    <>
      <div className={classes.delivery_signature_wrapper}>
        <div className={classes.delivery_signature_pad_wrapper}>
          <h3>Signature pad</h3>

          <div className={classes.attached_count}>
            Attached count:
            {' '}
            {selectedIds.length + 1}
          </div>

          <div className={`${classes.delivery_signature_canvas_wrapper} ${error ? classes.error : ''}`}>
            <SignatureCanvas
              ref={signPad}
              penColor="black"
              canvasProps={{
                width: 340,
                height: 270,
              }}
              onEnd={addSignature}
            />
          </div>

          <div className={classes.delivery_signature_btns_wrapper}>
            <Button
              title="Cancel"
              clearButton
              className={classes.accept_btn}
              onClick={() => navigate(`/deliveries${state || ''}`)}
            />

            <Button
              title="Clear"
              buttonColor="red"
              reverseColor
              className={classes.accept_btn}
              onClick={clearSignature}
            />

            <Button
              title="Accept"
              reverseColor
              loading={saveLoading}
              className={classes.accept_btn}
              onClick={saveSignature}
            />

            {/* <Button */}
            {/*  title="Add more" */}
            {/*  loading={loading} */}
            {/*  disabled={!loading && !deliveries.length} */}
            {/*  className={classes.accept_btn} */}
            {/*  onClick={() => !saveLoading && !!deliveries.length && changeModalData({ addMoreOpen: true })} */}
            {/* /> */}

            <Button
              title="Scan more"
              className={classes.accept_btn}
              disabled={saveLoading}
              onClick={() => !saveLoading && changeModalData({ scannerOpen: true })}
            />
          </div>
        </div>
      </div>

      <Modal
        open={scannerOpen}
        onClose={() => changeModalData({ scannerOpen: false })}
        className={classes.scanner_modal}
      >
        <div className={classes.scanner_modal_content}>
          <h3>Scan delivery</h3>

          <Scanner
            formats={['qr_code']}
            constraints={{
              facingMode: 'environment',
              width: { ideal: 720 },
              height: { ideal: 720 },
              audio: true,
              // zoom: 2,
            }}
            onScan={scan}
            onError={(err) => {
              console.warn(err);
              toast.error(err?.message || 'Camera error');
            }}
          />
        </div>
      </Modal>

      {/* <Modal */}
      {/*  open={addMoreOpen} */}
      {/*  onClose={() => changeModalData({ addMoreOpen: false })} */}
      {/*  className={classes.add_more_modal} */}
      {/* > */}
      {/*  <div className={classes.add_more_modal_content}> */}
      {/*    <h3>Select Deliveries</h3> */}

      {/*    {loading */}
      {/*      ? <Loader className={classes.loader} /> */}

      {/*      : ( */}
      {/*        <div className={classes.add_more_table_wrapper}> */}
      {/*          <Table */}
      {/*            data={deliveries} */}
      {/*            header={modalTableHeader} */}
      {/*            checkedItems={selectedIds} */}
      {/*            onCheck={(ids) => changeModalData({ selectedIds: ids })} */}
      {/*          /> */}
      {/*        </div> */}
      {/*      )} */}

      {/*    <div className={classes.add_more_modal_btns}> */}
      {/*      <Button */}
      {/*        title="Cancel" */}
      {/*        clearButton */}
      {/*        onClick={() => changeModalData({ addMoreOpen: false, selectedIds: [] })} */}
      {/*      /> */}

      {/*      <Button */}
      {/*        title="Confirm" */}
      {/*        reverseColor */}
      {/*        disabled={!selectedIds.length} */}
      {/*        onClick={() => changeModalData({ addMoreOpen: false })} */}
      {/*      /> */}
      {/*    </div> */}
      {/*  </div> */}
      {/* </Modal> */}
    </>
  );
};

export default DriverDeliverySign;
